export enum ECommercialOwnershipVerificationFormViewFields {
  Inn = 'inn',
  IdentificationPersonType = 'identificationPersonType',
  LastName = 'lastName',
  FirstName = 'firstName',
  SecondName = 'secondName',
  CadastralNumber = 'cadastralNumber',
  CompanyName = 'companyName',
}

export enum EIdentificationPersonType {
  /** Физическое лицо */
  Natural = 'natural',
  /** Индивидуальный предприниматель */
  Ip = 'ip',
  /** Юридическое лицо */
  Legal = 'legal',
}

export enum EIdentificationPersonTypeNone {
  None = 'none',
}

export type EIdentificationPersonTypeExtended = EIdentificationPersonType | EIdentificationPersonTypeNone;
